// The CSV's `bibtext` column is pre-formatted BibTeX generated upstream.
// Some years (2021-2025 at least) have field values that aren't wrapped in
// `{}` (only `pages` reliably is), which makes the entry invalid BibTeX --
// pasting it into a .bib file breaks on the bare `title=...` etc. Other
// years (2019, 2020) are already correctly braced.
//
// Rather than patch the CSVs themselves (which would need redoing for every
// future year), this re-parses whatever `bibtext` string is present and
// re-emits every field wrapped in `{}`, leaving already-correct `{...}`
// values untouched (idempotent) so it's safe regardless of which year's
// data it's given.
const FIELD_NAMES = ['title', 'author', 'booktitle', 'DOI', 'pages', 'year', 'organization'];

export const formatBibtex = (raw) => {
  if (!raw) return raw;

  const headerMatch = raw.match(/^@(\w+)\{([^,]+),/);
  if (!headerMatch) return raw; // not in the expected shape; leave untouched

  const [fullHeader, entryType, citeKey] = headerMatch;
  const closingBraceIndex = raw.lastIndexOf('}');
  if (closingBraceIndex < fullHeader.length) return raw;
  const body = raw.slice(fullHeader.length, closingBraceIndex);

  const fieldPattern = new RegExp(`(?:^|\\n)\\s*(${FIELD_NAMES.join('|')})\\s*=\\s*`, 'g');

  const parts = [];
  let match;
  let lastIndex = 0;
  let lastField = null;
  while ((match = fieldPattern.exec(body)) !== null) {
    if (lastField !== null) {
      parts.push([lastField, body.slice(lastIndex, match.index)]);
    }
    lastField = match[1];
    lastIndex = fieldPattern.lastIndex;
  }
  if (lastField !== null) {
    parts.push([lastField, body.slice(lastIndex)]);
  }

  if (parts.length === 0) return raw; // nothing recognizable; leave untouched

  const fields = parts.map(([name, value]) => {
    let v = value.trim().replace(/,\s*$/, '').replace(/\s+/g, ' ');
    if (!(v.startsWith('{') && v.endsWith('}'))) {
      v = `{${v}}`;
    }
    return `  ${name} = ${v}`;
  });

  return `@${entryType}{${citeKey},\n${fields.join(',\n')}\n}`;
};
